import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from "vue";
import TagChips from "@/components/dashboard/TagChips.vue";
import { substatusChipDefs } from "@/models/substatusTags";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubstatusChips',
    props: {
        tags: { default: () => [] },
        definitions: { default: () => [] },
        size: { default: "sm" }
    },
    setup(__props) {
        const props = __props;
        const chipDefs = computed(() => substatusChipDefs(props.tags, props.definitions));
        const chipKeys = computed(() => chipDefs.value.map((d) => d.key));
        return (_ctx, _cache) => {
            return (chipDefs.value.length)
                ? (_openBlock(), _createBlock(TagChips, {
                    key: 0,
                    tags: chipKeys.value,
                    "tag-defs": chipDefs.value,
                    size: __props.size
                }, null, 8, ["tags", "tag-defs", "size"]))
                : _createCommentVNode("", true);
        };
    }
});
